/* global axios */
import ApiClient from './ApiClient';

class RealEstateBrokerPaymentMethodsAPI extends ApiClient {
  constructor() {
    super('real_estate_broker_payment_methods', { accountScoped: true });
  }

  catalog() {
    return axios.get(`${this.url}/catalog`);
  }

  list() {
    return axios.get(this.url);
  }

  create(paymentMethod) {
    return axios.post(this.url, { payment_method: paymentMethod });
  }

  update(id, paymentMethod) {
    return axios.patch(`${this.url}/${id}`, { payment_method: paymentMethod });
  }
}

export default new RealEstateBrokerPaymentMethodsAPI();
